import { Injectable } from '@angular/core';
import { addIcons } from 'ionicons';
import { 
    closeOutline, closeCircleOutline, alertCircleOutline, checkmarkCircleOutline, warningOutline,eyeOutline, eyeOffOutline, searchOutline, 
    refreshOutline, checkmarkOutline, informationCircleOutline, locateOutline, menuOutline, arrowForwardCircleOutline, medalOutline,
    playCircleOutline, hourglassOutline, flashOutline, people, peopleOutline, arrowBackOutline, trendingUpOutline, chatbubbleEllipsesOutline,
    chatbubbleEllipses, person, qrCodeOutline, helpCircleOutline, call, callOutline, mail, chatbubbleOutline, chatbubble, chevronUpOutline, 
    chevronDownOutline, helpCircle, checkmarkCircle, timeOutline, caretDownOutline, documentAttachOutline, clipboardOutline, downloadOutline,
    addOutline, documentOutline, cogOutline, lockClosed, notificationsCircleOutline, thumbsUpOutline, giftOutline, checkboxOutline, squareOutline,
    logInOutline, bookmarkOutline
} from 'ionicons/icons';

@Injectable({
    providedIn: 'root'
})
export class IconsService {

    constructor() { }
    
    init(){
        addIcons({       
            closeOutline,
            closeCircleOutline,
            alertCircleOutline, 
            checkmarkCircleOutline,
            warningOutline,
            eyeOutline,
            eyeOffOutline,
            searchOutline, 
            refreshOutline,
            checkmarkOutline,
            informationCircleOutline,
            locateOutline,
            menuOutline,
            arrowForwardCircleOutline,
            medalOutline,
            playCircleOutline,
            hourglassOutline,
            flashOutline,
            people,
            peopleOutline,
            arrowBackOutline,
            trendingUpOutline,
            chatbubbleEllipsesOutline,
            chatbubbleEllipses,
            person,
            qrCodeOutline,
            helpCircleOutline,
            call,
            callOutline,
            mail,
            chatbubble,
            chatbubbleOutline, 
            chevronUpOutline, 
            chevronDownOutline, 
            helpCircle, 
            checkmarkCircle,
            timeOutline,
            caretDownOutline,
            documentAttachOutline,
            clipboardOutline,
            downloadOutline,
            addOutline,
            documentOutline,
            cogOutline,
            lockClosed,
            notificationsCircleOutline,
            thumbsUpOutline,
            giftOutline, 
            checkboxOutline, 
            squareOutline,
            logInOutline,
            bookmarkOutline
        });
    }
    
}

